export const RAYIC_TABS = [
    { id: "ozet", label: "Komuta", icon: "BarChart3" },
    { id: "arastir", label: "Araştır", icon: "Search" },
    { id: "parca", label: "Parça", icon: "Wrench" },
    { id: "uyarilar", label: "Uyarılar", icon: "AlertTriangle" },
    { id: "segmentler", label: "Segmentler", icon: "Database" },
    { id: "derin", label: "Derin", icon: "Globe" },
    { id: "rapor", label: "Rapor", icon: "FileText" },
];

export const RAYIC_WORKFLOW = [
    { id: "secim", label: "Araç", desc: "Marka / dosya seç" },
    { id: "tarama", label: "Tarama", desc: "Piyasa + web" },
    { id: "analiz", label: "Analiz", desc: "Rayiç + parça" },
    { id: "rapor", label: "Rapor", desc: "PDF / dosya" },
];

export function deriveRayicWorkflow({ form, sonuc, parcaSonuc, derinSonuc, kayitRapor }) {
    if (derinSonuc || kayitRapor) return "rapor";
    const parcaHazir =
        parcaSonuc?.parca_arastirma?.parcalar?.length ||
        parcaSonuc?.parcalar?.length ||
        parcaSonuc?.hasar_farki;
    if (parcaHazir) return "rapor";
    if (sonuc?.onerilen_rayic || parcaSonuc) return "analiz";
    if (form.marka && form.model) return "tarama";
    return "secim";
}

/** Rapor API payload — oturum içi analiz sonucunu DB'ye bağımlı olmadan gönderir */
export function buildRayicRaporPayload({
    dosyaId,
    derinSonuc,
    parcaSonuc,
    parcaHasar,
    sonuc,
    template = "ultra",
}) {
    const kaynak = parcaSonuc || {};
    const parcaArastirma = kaynak.parca_arastirma || (kaynak.parcalar ? kaynak : null);
    const hasInline =
        parcaArastirma?.parcalar?.length ||
        kaynak.belge_analiz?.parcalar?.length ||
        kaynak.cikarilan_parcalar?.length ||
        kaynak.hasar_farki ||
        parcaHasar;

    const parcaPayload = hasInline
        ? {
              ...kaynak,
              parca_arastirma: parcaArastirma || kaynak.parca_arastirma,
              hasar_farki: parcaHasar || kaynak.hasar_farki,
          }
        : undefined;

    const payload = {
        derin_sonuc: derinSonuc || undefined,
        parca_sonuc: parcaPayload,
        arastir_sonuc: sonuc || undefined,
        template,
    };
    if (dosyaId) payload.dosya_id = Number(dosyaId);
    return payload;
}

export function hasRayicRaporVerisi({ parcaSonuc, derinSonuc, dosyaId, parcaHasar }) {
    if (derinSonuc?.parca_arastirma?.parcalar?.length) return true;
    if (derinSonuc?.parca_arastirma) return true;
    if (parcaSonuc?.parca_arastirma?.parcalar?.length) return true;
    if (parcaSonuc?.parcalar?.length) return true;
    if (parcaSonuc?.belge_analiz?.parcalar?.length) return true;
    if (parcaSonuc?.cikarilan_parcalar?.length) return true;
    if (parcaHasar || parcaSonuc?.hasar_farki) return true;
    if (dosyaId) return true;
    return false;
}

export function tl(n) {
    if (n == null || n === "") return "—";
    return `₺${Number(n).toLocaleString("tr-TR", { maximumFractionDigits: 0 })}`;
}

export function pct(n) {
    if (n == null || n === "") return "—";
    const v = Number(n);
    const sign = v > 0 ? "+" : "";
    return `${sign}${v.toFixed(1)}%`;
}

export function parcaOrijinalFiyat(p) {
    return p?.orijinal_oneri ?? p?.orijinal_medyan;
}

export function parcaMuadilFiyat(p) {
    return p?.muadil_oneri ?? p?.muadil_medyan;
}
